module.exports = __webpack_public_path__ + "media/video-start.f3dad35c.mp4";